import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { comparisonRows } from '../../data/programa';
export function EliteProtocol() {
  return <section id="elite" className="radial-navy border-b border-line py-[60px] lg:py-[100px]" data-id="element-62" data-mp="3ixv5sr8fwru0">
      <div className="mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-63" data-mp="3e0biz2xof6qg">
        <SectionHeading eyebrow="Programa Élite" title={<>
              Para cuando la jornada{' '}
              <span className="text-gold" data-id="element-65" data-mp="ajw376qyq87j">se sale del guion</span>
            </>} data-id="element-64" data-mp="ehtssaonawbg" />

        <Reveal delay={0.06} className="mx-auto mt-10 max-w-3xl text-left" data-id="element-66" data-mp="5ogs2mkcaqet">
          <div className="glass overflow-hidden" data-id="element-67" data-mp="rgk263xjdl2">
            <div className="grid grid-cols-[1fr_72px_1fr] items-center gap-3 border-b border-line px-5 py-3.5 sm:grid-cols-[1.3fr_90px_1fr]" data-id="element-68" data-mp="y7mcx8l7j1sk">
              <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-69" data-mp="tet4a9mmb9b7">
                Situación
              </span>
              <span className="text-center text-[11px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-70" data-mp="1mkbe8ss333yv">
                Programa
              </span>
              <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-71" data-mp="18sof8l6rbhce">
                Élite
              </span>
            </div>
            <ul className="divide-y divide-line" data-id="element-72" data-mp="yva32xrv9epw">
              {comparisonRows.map(row => <li key={row.capability} className="grid grid-cols-[1fr_72px_1fr] items-center gap-3 px-5 py-3.5 sm:grid-cols-[1.3fr_90px_1fr]" data-id="element-73" data-mp="13ttkqlzfg4cg">
                  <span className="text-[13px] font-semibold leading-[1.45] text-ice" data-id="element-74" data-mp="tvnq8pfya0hm">
                    {row.capability}
                  </span>
                  <span className="flex justify-center" data-id="element-75" data-mp="2k8v00dmbn2n8">
                    {row.standard ? <CheckIcon className="h-4 w-4 text-gold" strokeWidth={2.5} aria-label="Incluido" data-id="element-76" data-mp="2o9ev7bnc3w6q" /> : <MinusIcon className="h-4 w-4 text-cool" strokeWidth={2.5} aria-label="No incluido" data-id="element-77" data-mp="3sa51pr4rvoui" />}
                  </span>
                  <span className="flex items-start gap-2 text-[13px] leading-[1.45] text-ice" data-id="element-78" data-mp="jqxghxeb1s2u">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-79" data-mp="fq59laswnz9q" />
                    {row.elite}
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}